import React from 'react';
import { Box, Typography } from '@mui/material';
import { DateObject, CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';
import { AppointmentRecurring } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { CardSubtitle } from './card-subtitle.component';


export type ConfirmationCardSessionInfoProps = {
  fromDatetime: DateObject | string;
  recurring: AppointmentRecurring;
};


export const ConfirmationCardSessionInfo: React.FC<ConfirmationCardSessionInfoProps> = (props) => {
  const l10n = useL10n();
  const timezone = useTimezone();

  const fromDatetime = React.useMemo(() => {
    return CalendarDateService.date(props.fromDatetime).tz(timezone);
  }, [ props.fromDatetime, timezone ]);

  const date = React.useMemo(() => {
    return fromDatetime.format('dddd, MMMM D, YYYY');
  }, [ fromDatetime ]);

  const slot = React.useMemo(() => {
    const from = fromDatetime.format('h:mm');
    const fromAmPm = fromDatetime.format('A');
    const to = fromDatetime.add(60, 'minutes').format('h:mm');

    return `${from} - ${to} ${fromAmPm}`;
  }, [ fromDatetime ]);

  const recurring = React.useMemo(() => {
    if (!props.recurring || props.recurring === AppointmentRecurring.none) {
      return null;
    }

    const day = fromDatetime.format('dddd');

    return `Recurring ${props.recurring} on ${day}`;
  }, [ props.recurring, fromDatetime ]);

  return (
    <Box>
      <CardSubtitle color="secondary" variant="body1">{l10n.sessions.nextSession}</CardSubtitle>
      <Typography>{date}</Typography>
      <Typography variant="h5">{slot}</Typography>
      {recurring && <Typography variant="body2">{recurring}</Typography>}
    </Box>
  );
};
